import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as interstateService from '../../services/interstate';
import actions from './actions';
import toastr from 'toastr';
import {history} from "../../index";

export function* list({ payload }) {
  const { countryId, page, sorting, filter } = payload;

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingList: true,
    },
  });

  const response = yield call(interstateService.list, countryId, page, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        list: data.data,
        meta: data.meta
      },
    })
  }

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingList: false,
    },
  })
}

export function* members({ payload }) {
  const { countryId, page, sorting, filter } = payload;

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingMembers: true,
    },
  });

  const response = yield call(interstateService.members, countryId, page, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        members: data.data,
        membersMeta: data.meta
      },
    })
  }

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingMembers: false,
    },
  })
}

export function* contacts({ payload }) {
  const { countryId, page, sorting, filter } = payload;

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingContacts: true,
    },
  });

  const response = yield call(interstateService.contacts, countryId, page, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        contacts: data.data,
        contactsMeta: data.meta
      },
    })
  }

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingContacts: false,
    },
  })
}

export function* parents({ payload }) {
  const { countryId, page, sorting, filter } = payload;

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingParents: true,
    },
  });

  const response = yield call(interstateService.parents, countryId, page, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        parents: data.data,
        parentsMeta: data.meta
      },
    })
  }

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingParents: false,
    },
  })
}

export function* exportRegistrations({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(interstateService.exportRegistrations, countryId, sorting, filter, format, name);
}

export function* exportRegistrationsMembers({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(interstateService.exportRegistrationsMembers, countryId, sorting, filter, format, name);
}

export function* exportRegistrationsContacts({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(interstateService.exportRegistrationsContacts, countryId, sorting, filter, format, name);
}

export function* exportRegistrationsParents({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(interstateService.exportRegistrationsParents, countryId, sorting, filter, format, name);
}

export function* print({ payload }) {
  const { countryId, sorting, filter } = payload;

  const response = yield call(interstateService.print, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        printData: data.data,
        activatePrint: true
      },
    })
  }
}

export function* printMembers({ payload }) {
  const { countryId, sorting, filter } = payload;

  const response = yield call(interstateService.printMembers, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        printMembersData: data.data,
        activateMembersPrint: true
      },
    })
  }
}

export function* printContacts({ payload }) {
  const { countryId, sorting, filter } = payload;

  const response = yield call(interstateService.printContacts, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        printContactsData: data.data,
        activateContactsPrint: true
      },
    })
  }
}

export function* printParents({ payload }) {
  const { countryId, sorting, filter } = payload;

  const response = yield call(interstateService.printParents, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        printParentsData: data.data,
        activateParentsPrint: true
      },
    })
  }
}

export function* refreshPrint() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      printData: [],
      activatePrint: false
    },
  })
}

export function* refreshMembersPrint() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      printMembersData: [],
      activateMembersPrint: false
    },
  })
}

export function* refreshContactsPrint() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      printContactsData: [],
      activateContactsPrint: false
    },
  })
}

export function* refreshParentsPrint() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      printParentsData: [],
      activateParentsPrint: false
    },
  })
}

export function* emails({ payload }) {
  const { countryId, sorting, filter } = payload;

  const response = yield call(interstateService.emails, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        emails: data.data
      },
    })
  }
}

export function* emailsConfirmation({ payload }) {
  const { countryId, sorting, filter, data } = payload;

  const response = yield call(interstateService.emailsConfirmation, countryId, sorting, filter, data);

  if (response && response.status === 200) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }
}

export function* refreshEmails() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      emails: []
    },
  })
}

export function* details({ payload }) {
  const { countryId, id } = payload;

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(interstateService.details, countryId, id);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        details: data.data
      },
    })
  }

  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* add({ payload }) {
  const response = yield call(interstateService.add, payload);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push(`/country/${payload.countryId}/interstates`);
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'interstate/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* edit({ payload }) {
  const { countryId, id, data } = payload;

  const response = yield call(interstateService.edit, countryId, id, data);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push(`/country/${countryId}/interstates`);
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'interstate/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* remove({ payload }) {
  const { countryId, id, page } = payload;

  const response = yield call(interstateService.remove, countryId, id);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    return yield call(list.bind(null, { payload: { countryId, page: page ?? 1}}));
  }

  if (response && response.status >= 400 && response.status <= 422) {
    toastr.error(response.data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }
}

export function* refreshErrors() {
  yield put({
    type: 'interstate/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export function* changeIsDeactivated({ payload }) {
  const response = yield call(interstateService.changeIsDeactivated, payload.id, payload.isDeactivated);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield put({
      type: 'interstate/SET_STATE',
      payload: {
        isDeactivatedObject: {
          id: payload.id,
          is_deactivated: payload.isDeactivated
        },
      }
    });
    yield history.push(`/country/${payload.countryId}/interstates`);
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'interstate/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REFRESH_CONTACTS_PRINT, refreshContactsPrint),
    takeEvery(actions.REFRESH_MEMBERS_PRINT, refreshMembersPrint),
    takeEvery(actions.REFRESH_PARENTS_PRINT, refreshParentsPrint),
    takeEvery(actions.REFRESH_PRINT, refreshPrint),
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
    takeEvery(actions.EMAILS, emails),
    takeEvery(actions.EMAILS_CONFIRMATION, emailsConfirmation),
    takeEvery(actions.REFRESH_EMAILS, refreshEmails),
    takeEvery(actions.FETCH_ALL, list),
    takeEvery(actions.FETCH_MEMBERS_ALL, members),
    takeEvery(actions.FETCH_CONTACTS_ALL, contacts),
    takeEvery(actions.FETCH_PARENTS_ALL, parents),
    takeEvery(actions.EXPORT, exportRegistrations),
    takeEvery(actions.EXPORT_MEMBERS, exportRegistrationsMembers),
    takeEvery(actions.EXPORT_CONTACTS, exportRegistrationsContacts),
    takeEvery(actions.EXPORT_PARENTS, exportRegistrationsParents),
    takeEvery(actions.PRINT_MEMBERS, printMembers),
    takeEvery(actions.PRINT_CONTACTS, printContacts),
    takeEvery(actions.PRINT_PARENTS, printParents),
    takeEvery(actions.PRINT, print),
    takeEvery(actions.DETAILS, details),
    takeEvery(actions.ADD, add),
    takeEvery(actions.EDIT, edit),
    takeEvery(actions.REMOVE, remove),
    takeEvery(actions.CHANGE_IS_DEACTIVATED, changeIsDeactivated)
  ])
}
